import { ReactElement } from 'react';

export interface KycApprovedSummaryCardProps {
	documentImageUrl: string;
	faceImageUrl: string;
}

export const KycApprovedSummaryCard = (props: KycApprovedSummaryCardProps): ReactElement => {
	const { documentImageUrl, faceImageUrl } = props;

	return (
		<div className="kyc-approved-card">
			<div className="kyc-approved-card__legend">KYC Verification</div>
			<div className="kyc-approved-card__body">
				<div className="kyc-approved-card__thumbs">
					<div className="kyc-approved-card__thumb">
						{documentImageUrl ? (
							<img src={documentImageUrl} alt="" className="kyc-approved-card__thumb-img" role="presentation" />
						) : (
							<div className="kyc-approved-card__thumb-placeholder" aria-hidden />
						)}
					</div>
					<div className="kyc-approved-card__thumb">
						{faceImageUrl ? (
							<img src={faceImageUrl} alt="" className="kyc-approved-card__thumb-img" role="presentation" />
						) : (
							<div className="kyc-approved-card__thumb-placeholder" aria-hidden />
						)}
					</div>
				</div>
				<div className="kyc-approved-card__status-bar">KYC APPROVED</div>
			</div>
		</div>
	);
};
